var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.3,11.2l1.3,1.3L12,8L7.6,3.6L6.3,4.8l2.3,2.3H0v1.8h8.6L6.3,11.2z M14.2,0H1.8C0.8,0,0,0.8,0,1.8v3.6h1.8V1.8h12.4v12.4\n\tH1.8v-3.6H0v3.6c0,1,0.8,1.8,1.8,1.8h12.4c1,0,1.8-0.8,1.8-1.8V1.8C16,0.8,15.2,0,14.2,0z","fill":"currentColor"}));
}

Exit.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Exit;

Exit.default = Exit;
